// Core
import React, { useEffect, useCallback, useState } from 'react';
import { Box, Button, Flex, Grid, Text, Image, useColorMode, useDisclosure} from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

// Assets
import { formatDateWithSuffix, colorUserSubLayout, colorUserSubBg } from 'services/Utils';
import profileSub from 'assets/img/profile-sub.png';
import emptyPlan from 'assets/img/empty-plan.png';

// Components
import AttentionModal from 'components/Modals/AttentionModal';

const ActivePlan = (props) => { 
  const { userData } = props;

  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  return (
	<>
		<Box maxW="364px" h={userData?.activePlan ? 'auto' : '87px'} p="12px" borderRadius="16px" position="relative" overflow="hidden">
			<Image 
				zIndex="2"
				opacity="0.2"
				src={userData?.activePlan?.image || emptyPlan} alt="Profile" 
				right="-15%" top="-30%" objectFit="cover" position="absolute" w="300px" h="300px"/>

			<Box position="absolute" top="0" left="0"
				zIndex="1"
				bg={() => colorUserSubLayout(userData?.activePlan?.type)}
				w="100%" h="100%"/>

			<Flex gap="12px" width="100%" justifyContent="space-between" zIndex="1" position="relative" zIndex="3">
				<Flex gap="12px" alignItems="center">
					<Box
					  w="64px"
					  h="64px"
					  p="10px"
					  bg={() => colorUserSubBg(userData?.activePlan?.type)}
					  boxShadow="0px 2.56px 9.344px 0px rgba(0, 0, 0, 0.25)"
					  borderRadius="12px">
					  <Image src={userData?.activePlan?.image || emptyPlan} w="44px" maxW="44px" h="44px" alt="Plan" />
					</Box>

					<Text variant="title-lg" 
						lineHeight="20px"
						mt="-2px" fontSize="20px" fontStyle="normal" fontWeight="800" color="white">
					    {userData?.activePlan?.name}
					</Text>
				</Flex>

				{ userData?.activePlan && (
			      <NavLink to="/account/membership">
			        <Text
			          variant="title-md"
			          h="26px"
			          padding="3px 9px"
			          borderRadius="100px"
			          cursor="pointer"
			          onClick={props.onClose}
			          bg={ isDark ? '#0F1426' : 'white'}>Manage</Text>
			      </NavLink>
				)}
			</Flex>

			{ /*<Box zIndex="3" position="relative" mt="8px">
		    { userData?.activePlan &&
		    	<Text variant="title-lg" fontSize="24px" fontStyle="normal" fontWeight="700" color="white">
				    ${userData?.activePlan?.price / 100} <span style={{fontSize: '17px', marginLeft: '-5px'}}>/{userData?.activePlan?.paymentType === 'monthly' ? 'month' : 'year' }</span>
					</Text>
		    }
				<Text variant="title-lg" fontSize="15px" color="white">{ userData?.activePlan?.canceledAt === null ? 'Next payment on' : 'Subscription Canceled'} </Text>
				{ userData?.activePlan?.canceledAt === null ? (
				    <Text variant="title-lg" fontSize="15px" color="white">{formatDateWithSuffix(userData?.activePlan?.nextBillingDate)} for ${userData?.activePlan?.price / 100}</Text>
				) : (
				    <Text variant="title-lg" fontSize="15px" color="white">No upcoming payments. Your plan features remain available until {formatDateWithSuffix(userData?.activePlan?.nextBillingDate)}</Text>
				) }
			</Box> */ }

			{ userData?.activePlan?.canceledAt !== null &&
				<Box zIndex="3" position="relative" mt="8px">
					<Text variant="title-lg" fontSize="15px" color="white">Subscription Canceled</Text> 
				  <Text variant="title-lg" fontSize="15px" color="white">Available until {formatDateWithSuffix(userData?.activePlan?.nextBillingDate)}</Text>
				</Box>
			}
		</Box>
	</>
  );
};

export default ActivePlan;